import { render, staticRenderFns } from "./solutionDetails.vue?vue&type=template&id=5391cf49&scoped=true"
import script from "./solutionDetails.vue?vue&type=script&lang=js"
export * from "./solutionDetails.vue?vue&type=script&lang=js"
import style0 from "./solutionDetails.vue?vue&type=style&index=0&id=5391cf49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5391cf49",
  null
  
)

export default component.exports